import { useMemo } from "react";
import ReactImageMagnify from 'react-image-magnify';
import { FlagRegionByIso } from "components/Function";
import { Link } from "react-router-dom";

const useColumnTableProductsByInfluencer = (heightRow = 100, dayRanger) => {
    const columns = useMemo(() => {
        return [
            {
                field: "_id",
                headerName: "",
                sortable: false,
                editable: false,
                cellClass: "centered-cell",
                width: 10,
                cellRenderer: ({ rowIndex, value: cell, data: row }) => rowIndex + 1,
            },
            {
                field: "product_name",
                headerName: "Product",
                sortable: false,
                editable: false,
                autoHeight: true,
                cellClass: "overflow-visible",
                width: 500,
                cellRenderer: ({ data: row, cell }) => (
                    <div className="d-flex align-items-center p-4" style={{ height: heightRow - 1 + "px" }}>
                        <div className="symbol symbol-60px symbol-lg-80px symbol-fixed position-relative me-3">
                            {/* <Link to={row.cover_url} target="_blank"> */}
                                <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: row.cover_url }, largeImage: { src: row.cover_url, width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 99 }, imageClassName: "overflow-hidden al-border-radius-8" }} />
                            {/* </Link> */}
                        </div>
                        <div
                            className="d-flex flex-column lh-lg gap-2 w-100px"
                            style={{
                                overflow: "hidden",
                                flex: "1",
                            }}
                        >
                            <span
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={row.product_name}
                                className="mb-0"
                                style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    flex: "1",
                                }}
                            >
                                <Link
                                    role="button"
                                    target="_blank"
                                    to={`/admin/spy-advanced/products/${row.product_id}`}
                                >
                                    {row.product_name}
                                </Link>
                            </span>
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                <span
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content={"Price"}
                                    className="fs-6 text-danger mb-0"
                                >
                                    {row.real_price}
                                </span>
                                {row.commission && (
                                    <span
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content={"Commission"}
                                        className="badge bg-warning text-white rounded-pill"
                                    >
                                        {row.commission}
                                    </span>
                                )}
                            </div>
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                {row.region?.key ? (
                                    <FlagRegionByIso name={row.region.name} iso={row.region.key} />
                                ) : (
                                    ""
                                )}
                                <span className="badge bg-info text-white rounded-pill">{row.category_name}</span>
                                <span
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content={"Product Experience Points"}
                                    className="badge bg-info text-white"
                                >
                                    {row.product_rating}
                                </span>
                                <span
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content={"Comments"}
                                    className="badge bg-info text-white"
                                >
                                    {row.review_count}
                                </span>
                                {Boolean(row.is_free_shipping) && (
                                    <i
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content={"Free Shipping"}
                                        className="fas fa-shipping-fast fs-3"
                                    ></i>
                                )}
                            </div>
                        </div>
                    </div>
                ),
            },
            {
                field: "avg_price",
                headerName: "Prices",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "total_sale_cnt",
                headerName: "Sales",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "total_gmv_amt",
                headerName: "GMV",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "videos_count",
                headerName: "Video",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "lives_count",
                headerName: "Live",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "-",
                headerName: "Actions",
                editable: false,
                cellClass: "centered-cell",
                width: 140,
                // pinned: "right",
                cellRenderer: ({ data: row }) => (
                    <>
                        <Link
                            role="button"
                            to={`/admin/spy-advanced/products/${row.product_id}`}
                            className="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-2"
                            data-tooltip-id="my-tooltip"
                            target="_blank"
                        >
                            <i className="fa fa-search fs-2"></i>
                        </Link>
                    </>
                ),
            },
        ];
    }, [heightRow, dayRanger]);

    return columns;
};

export default useColumnTableProductsByInfluencer;
